import SelectedServicesHeader from "./SelectedServicesHeader";
import SelectedServicesBody from "./SelectedServicesBody";
import SelectedServicesFooter from "./SelectedServicesFooter";

const SelectedServicesPanel = ({
  data,
  exporting,
  previewing,
  onExport,
  onPreview,
}) => {
  return (
    <div className="flex h-full min-h-0 w-full flex-col rounded-[16px] p-0 md:bg-[linear-gradient(225deg,#F9F9F9_-10.52%,#EFEFEF_100.34%)] md:p-4">
      <h2 className="mb-4 shrink-0 text-xl font-bold text-gray-800">
        Dịch Vụ Đã Chọn
      </h2>

      <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl border border-[#E3E3E3] bg-white md:rounded-2xl">
        <div className="min-h-0 flex-1 overflow-x-auto">
          <div className="flex h-full min-h-0 min-w-[900px] flex-col">
            <SelectedServicesHeader />
            <div className="min-h-0 flex-1 overflow-y-auto">
              <SelectedServicesBody data={data} />
            </div>
          </div>
        </div>
        <SelectedServicesFooter
          subtotal={data.calculateTotal()}
          vat={data.calculateTotalVat()}
          total={data.calculateFinalTotal()}
          exporting={exporting}
          previewing={previewing}
          onExport={onExport}
          onPreview={onPreview}
          disabled={data.selectedServices.length === 0}
        />
      </div>
    </div>
  );
};

export default SelectedServicesPanel;
